import { useEffect, useRef, useState } from "react";

const prefersStill = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;

/** Court footage behind the signed-out screens, under a shade so the form stays readable. */
export function Backdrop() {
    const video = useRef<HTMLVideoElement>(null);
    const [playing, setPlaying] = useState(false);
    const [still] = useState(prefersStill);

    useEffect(() => {
        const v = video.current;
        if (!v) return;
        // React sets `muted` as a property after mount, which iOS ignores for autoplay; set it first, then ask.
        v.muted = true;
        v.play().catch((err: unknown) => {
            // Low-power mode and data saver refuse autoplay; the poster underneath is the designed fallback.
            console.info("backdrop autoplay refused, showing the still", { reason: (err as { name?: string })?.name });
        });
    }, []);

    return (
        <div className="backdrop" aria-hidden>
            <img className="backdrop-media" src="/signin-bg.jpg" alt="" />
            {!still && (
                <video ref={video} className={`backdrop-media backdrop-video${playing ? " on" : ""}`} src="/signin-bg.mp4"
                    muted loop playsInline preload="auto" onPlaying={() => setPlaying(true)} />
            )}
            <div className="backdrop-shade" />
        </div>
    );
}
